import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

export default function PresenceAvatar({ src, name, online, className = "w-10 h-10", dotClass = "w-3 h-3", testid }) {
  return (
    <div className="relative shrink-0" data-testid={testid}>
      <Avatar className={className}>
        <AvatarImage src={src} />
        <AvatarFallback>{name?.[0]}</AvatarFallback>
      </Avatar>
      {online && (
        <span
          data-testid={testid ? `${testid}-online` : undefined}
          className={`absolute bottom-0 right-0 ${dotClass} rounded-full bg-emerald-500 ring-2 ring-background`}
          title="Online agora"
        />
      )}
    </div>
  );
}
